import { useSuspenseQuery } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';

import { useAxiosWithAPI } from '../../../../../../common/hooks/useAxiosWithAPI';
import { JobRoleWithQuestions } from '../../../../../../common/interfaces/entities';

export const jobRoleQuestionsQueryKey = (jobRoleId: string | undefined) =>
  ['job-role-keyword-questions', jobRoleId] as const;

export async function fetchJobRoleQuestions(
  axios: AxiosInstance,
  jobRoleId: string
) {
  const response = await axios.get<{ data: JobRoleWithQuestions }>(
    `/v2/job-roles/${jobRoleId}/keyword-questions`
  );
  return response.data.data;
}

export default function useGetJobRoleWithQuestions(
  jobRoleId: string | undefined,
  enabled: boolean
) {
  const axios = useAxiosWithAPI();

  const { data: jobRoleWithQuestions } = useSuspenseQuery({
    queryKey: jobRoleQuestionsQueryKey(jobRoleId),
    queryFn: async () => {
      if (!(jobRoleId && enabled)) {
        return null;
      }

      return fetchJobRoleQuestions(axios, jobRoleId);
    },
  });

  return jobRoleWithQuestions;
}
